// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
import ___CSS_LOADER_URL_IMPORT_0___ from "../fonts/Lato-Regular.ttf";
import ___CSS_LOADER_URL_IMPORT_1___ from "../fonts/Lato-Black.ttf";
import ___CSS_LOADER_URL_IMPORT_2___ from "../fonts/Lato-Bold.ttf";
import ___CSS_LOADER_URL_IMPORT_3___ from "../fonts/Lato-Heavy.ttf";
import ___CSS_LOADER_URL_IMPORT_4___ from "../fonts/Lato-Medium.ttf";
import ___CSS_LOADER_URL_IMPORT_5___ from "../fonts/Lato-MediumItalic.ttf";
import ___CSS_LOADER_URL_IMPORT_6___ from "../fonts/Lato-Semibold.ttf";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@font-face{font-family:\"Lato-Regular\";font-weight:400;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}@font-face{font-family:\"Lato\";font-weight:900;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ")}@font-face{font-family:\"Lato\";font-weight:bold;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ")}@font-face{font-family:\"Lato\";font-weight:bolder;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_3___ + ")}@font-face{font-family:\"Lato\";font-weight:lighter;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_4___ + ")}@font-face{font-family:\"Lato\";font-style:italic;font-weight:lighter;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_5___ + ")}@font-face{font-family:\"Lato\";font-weight:500;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_6___ + ")}body{font-family:\"Lato\"}a{text-decoration:none}p,span{font-size:14px;letter-spacing:0;line-height:20px;margin:0}button{border-color:rgba(0,0,0,0);cursor:pointer;padding:0}", "",{"version":3,"sources":["webpack://styles/defaults.scss"],"names":[],"mappings":"AAAsuC,WAAW,0BAA0B,CAAC,eAAe,CAAC,2CAAoC,CAAC,WAAW,kBAAkB,CAAC,eAAe,CAAC,2CAAkC,CAAC,WAAW,kBAAkB,CAAC,gBAAgB,CAAC,2CAAiC,CAAC,WAAW,kBAAkB,CAAC,kBAAkB,CAAC,2CAAkC,CAAC,WAAW,kBAAkB,CAAC,mBAAmB,CAAC,2CAAmC,CAAC,WAAW,kBAAkB,CAAC,iBAAiB,CAAC,mBAAmB,CAAC,2CAAyC,CAAC,WAAW,kBAAkB,CAAC,eAAe,CAAC,2CAAqC,CAAC,KAAK,kBAAkB,CAAC,EAAE,oBAAoB,CAAC,OAAO,cAAc,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,QAAQ,CAAC,OAAO,0BAA0B,CAAC,cAAc,CAAC,SAAS","sourcesContent":[":export{bannerRed:rgba(218,20,20,.1);bannerSuccess:rgba(90,202,117,.3);blue:#1c5898;boxShadowGrey:rgba(11,9,44,.2);btnActive:#0095e2;btnDefault:#2fb4f9;btnDisabled:#acb8bc;btnGhostActive:rgba(0,149,226,.1);btnGhostDefault:rgba(0,0,0,0);btnGhostHover:rgba(100,193,241,.1);btnHover:#64c1f1;btnSecondaryActive:rgba(0,149,226,.1);btnSecondaryDefault:rgba(47,180,249,.1);btnSecondaryDisabled:#f4f6f6;btnSecondaryHover:rgba(100,193,241,.1);charcoal:#333;coral:#ed7f69;darkGrey:#6b6c7e;error:#da1414;errorColor:#da1414;faintBlue:rgba(28,88,152,.05);green:#59bf28;grey:#acb8bc;lightBlue:#2fb4f9;lightGrayRuler:#f4f6f6;lightGrey:#f1f1f1;lightPineTree:#e5f3f0;modalOverlay:rgba(32,33,38,.45);modalWrapperBackground:rgba(0,0,0,.2);olive:#20cb9a;orange:#fe7a24;peach:#fdc;pineTree:#4e8c8a;primary:#26b1e2;primaryHover:#64c1f1;red:#fa1931;sea:rgba(47,181,249,.1);seaPrimary:#2fb4f9;seaPrimaryWithAlpha:rgba(47,180,249,.1);secondary:#ffa959;silver:#acb8bc;success:#70c063;warning:#ff8f39;white:#fff}:export{hugeFont:36px;inputHeight:38px;l:24px;lFont:18px;m:20px;s:16px;sFont:14px;slimButtonHeight:24px;smallestFont:10px;smallestSpacer:5px;spacer:15px;standardFont:14px;xl:28px;xs:12px;xsFont:12px;xxl:32px;xxs:8px;xxsFont:10px;xxxl:40px;xxxs:4px;xxxxl:64px;xxxxs:2px}@font-face{font-family:\"Lato-Regular\";font-weight:400;src:url(\"../fonts/Lato-Regular.ttf\")}@font-face{font-family:\"Lato\";font-weight:900;src:url(\"../fonts/Lato-Black.ttf\")}@font-face{font-family:\"Lato\";font-weight:bold;src:url(\"../fonts/Lato-Bold.ttf\")}@font-face{font-family:\"Lato\";font-weight:bolder;src:url(\"../fonts/Lato-Heavy.ttf\")}@font-face{font-family:\"Lato\";font-weight:lighter;src:url(\"../fonts/Lato-Medium.ttf\")}@font-face{font-family:\"Lato\";font-style:italic;font-weight:lighter;src:url(\"../fonts/Lato-MediumItalic.ttf\")}@font-face{font-family:\"Lato\";font-weight:500;src:url(\"../fonts/Lato-Semibold.ttf\")}body{font-family:\"Lato\"}a{text-decoration:none}p,span{font-size:14px;letter-spacing:0;line-height:20px;margin:0}button{border-color:rgba(0,0,0,0);cursor:pointer;padding:0}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerRed": "rgba(218,20,20,.1)",
	"bannerSuccess": "rgba(90,202,117,.3)",
	"blue": "#1c5898",
	"boxShadowGrey": "rgba(11,9,44,.2)",
	"btnActive": "#0095e2",
	"btnDefault": "#2fb4f9",
	"btnDisabled": "#acb8bc",
	"btnGhostActive": "rgba(0,149,226,.1)",
	"btnGhostDefault": "rgba(0,0,0,0)",
	"btnGhostHover": "rgba(100,193,241,.1)",
	"btnHover": "#64c1f1",
	"btnSecondaryActive": "rgba(0,149,226,.1)",
	"btnSecondaryDefault": "rgba(47,180,249,.1)",
	"btnSecondaryDisabled": "#f4f6f6",
	"btnSecondaryHover": "rgba(100,193,241,.1)",
	"charcoal": "#333",
	"coral": "#ed7f69",
	"darkGrey": "#6b6c7e",
	"error": "#da1414",
	"errorColor": "#da1414",
	"faintBlue": "rgba(28,88,152,.05)",
	"green": "#59bf28",
	"grey": "#acb8bc",
	"lightBlue": "#2fb4f9",
	"lightGrayRuler": "#f4f6f6",
	"lightGrey": "#f1f1f1",
	"lightPineTree": "#e5f3f0",
	"modalOverlay": "rgba(32,33,38,.45)",
	"modalWrapperBackground": "rgba(0,0,0,.2)",
	"olive": "#20cb9a",
	"orange": "#fe7a24",
	"peach": "#fdc",
	"pineTree": "#4e8c8a",
	"primary": "#26b1e2",
	"primaryHover": "#64c1f1",
	"red": "#fa1931",
	"sea": "rgba(47,181,249,.1)",
	"seaPrimary": "#2fb4f9",
	"seaPrimaryWithAlpha": "rgba(47,180,249,.1)",
	"secondary": "#ffa959",
	"silver": "#acb8bc",
	"success": "#70c063",
	"warning": "#ff8f39",
	"white": "#fff",
	"hugeFont": "36px",
	"inputHeight": "38px",
	"l": "24px",
	"lFont": "18px",
	"m": "20px",
	"s": "16px",
	"sFont": "14px",
	"slimButtonHeight": "24px",
	"smallestFont": "10px",
	"smallestSpacer": "5px",
	"spacer": "15px",
	"standardFont": "14px",
	"xl": "28px",
	"xs": "12px",
	"xsFont": "12px",
	"xxl": "32px",
	"xxs": "8px",
	"xxsFont": "10px",
	"xxxl": "40px",
	"xxxs": "4px",
	"xxxxl": "64px",
	"xxxxs": "2px"
};
export default ___CSS_LOADER_EXPORT___;
